import axios from 'axios'

export const getMulticenterOriginCenters = params => axios.get('/api/centers/multicenter/origins', { params })

export const getMulticenterProviders = params => axios.get('/api/providers/multicenter', { params })

export const getExistsMulticenterPendingOrders = () =>
  axios.get('/api/provider-orders/multicenter/exists-pending-to-receive')
